module.exports = __webpack_public_path__ + "static/media/services.303975ab.png";